import React from 'react';
import { Tooltip, Icon } from 'antd';
// eslint-disable-next-line import/no-extraneous-dependencies
import router from 'umi/router';
import { getPathHeader } from '../../../../../utils/utils';
import { getAppCode } from '../../utils/utils';

const columns = ({ startMonth, endMonth, activeKey, isPerson }) => [
  {
    title: '分组',
    dataIndex: 'nodeName',
    key: 'nodeName',
  },
  {
    title: '上报文章数',
    dataIndex: 'reportCounts',
    key: 'reportCounts',
  },
  {
    title: (
      <div>
        被上级组织征用数
        <Tooltip placement="top" title="上级组织审批通过或发布的文章数">
          <Icon type="question-circle" />
        </Tooltip>
      </div>
    ),
    dataIndex: 'successCounts',
    key: 'successCounts',
  },
  {
    title: '上报文章打回/撤下数',
    dataIndex: 'failCounts',
    key: 'failCounts',
  },
  {
    title: '正在审批文章数',
    dataIndex: 'ingCounts',
    key: 'ingCounts',
  },
  {
    title: '学校已撤回文章数',
    dataIndex: 'upCounts',
    key: 'upCounts',
  },
  {
    title: '操作',
    dataIndex: 'action',
    key: 'action',
    render: (text, record) => {
      const { nodeId = '', detail } = record || {};
      const typeValue =
        // 1为学校/2为教育局
        // eslint-disable-next-line no-nested-ternary
        activeKey === 'key2' && detail === 1 ? 'editor' : 'detail';
      const params = `appCode=${getAppCode()}&nodeId=${nodeId}&type=${typeValue}&activeKey=${activeKey}&startMonth=${startMonth}&endMonth=${endMonth}&isPerson=${isPerson}`;
      const url = `/${getPathHeader()}/manuscriptCount/reportstatistics/detail/${typeValue}?${params}`;

      return <a onClick={() => router.push(url)}>详情</a>;
    },
  },
];
const editorColums = [
  {
    title: '分组',
    dataIndex: 'nodeName',
    key: 'nodeName',
  },
  {
    title: '通讯员',
    dataIndex: 'publishUserName',
    key: 'publishUserName',
  },
  {
    title: '上报文章数',
    dataIndex: 'reportCounts',
    key: 'reportCounts',
  },
  {
    title: (
      <div>
        被上级组织征用数
        <Tooltip placement="top" title="上级组织审批通过或发布的文章数">
          <Icon type="question-circle" />
        </Tooltip>
      </div>
    ),
    dataIndex: 'successCounts',
    key: 'successCounts',
  },
  {
    title: '上报文章打回/撤下数',
    dataIndex: 'failCounts',
    key: 'failCounts',
  },
  {
    title: '正在审批文章数',
    dataIndex: 'ingCounts',
    key: 'ingCounts',
  },
  {
    title: '学校已撤回文章数',
    dataIndex: 'upCounts',
    key: 'upCounts',
  },
];

export { columns, editorColums };
